import { put, call, takeEvery } from "redux-saga/effects"
import { createField } from "src/engine/repositories/resourceTypeFields"
import { showToast } from "@infotech/uikit-toasts"
import get from "lodash/get"
import { CREATE } from "../actions/types"
import { createSuccess, createError } from "../actions/creators/create"

// create field saga
function* requestCreate(action) {
  const {
    config,
    config: { refreshGrid },
  } = action
  try {
    const response = yield call(createField, config)
    yield put(createSuccess(action, response))
    showToast({
      type: `success`,
      message: `Поле "${get(action, `config.data.name`)}" успешно создано.`,
      hideIn: 5,
    })
    refreshGrid()
  } catch (error) {
    yield put(createError(action, error))
  }
}

export default function* readSaga() {
  yield takeEvery(CREATE, requestCreate)
}
